import { render, staticRenderFns } from "./order-address.pug?vue&type=template&id=038e9140&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./order-address.scss?vue&type=style&index=0&id=038e9140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e9140",
  null
  
)

export default component.exports